import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

function usePreviousLocation() {
    const location = useLocation();
    const [prevLocation, setPrevLocation] = useState(null);
    const prevLocationRef = useRef(null);

    useEffect(() => {
        if (prevLocationRef.current) {
            setPrevLocation(prevLocationRef.current);
        }
        prevLocationRef.current = location.pathname;
    }, [location]);

    return prevLocation;
}

export default usePreviousLocation;
